import React from 'react';
import ListViewUniversalCard from './list-view-card';
import SquareViewCard from './square-view-card';
import { UniversalCardProps } from './types';
import { ListingCardWrapper } from './styled';
import { SearchViewMode } from 'components/list-view-switcher/constants';
import { URPotentialCard } from 'components/real-estate-listing-card';
import InvestorsMobileListingCard from './investors-mobile-card';
import { CardType } from '../types';
import { isNil } from 'lodash';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { useABTests } from 'hooks/useABTests';
import { URPotential } from 'config/abTests';

const UniversalCard: React.FC<UniversalCardProps> = (props) => {
  const { view, ...rest } = props;
  const { isInvestors } = props;
  const isMobile = useScreenBreakpoint() < 3;
  const { urPotentialMode } = useABTests();

  let card = null;
  const isURPotential = isInvestors && urPotentialMode === URPotential.modeB && rest.cardType === CardType.Bulletin
    && !isNil(rest.urbanRenewalStatus) && rest.urbanRenewalStatus !== -1;

  if (isInvestors && isMobile && view === SearchViewMode.List && rest.cardType === CardType.Bulletin) {
    return <InvestorsMobileListingCard {...rest} isURPotential={isURPotential} />;
  }

  switch (view) {
    case SearchViewMode.List:
      card = isURPotential ? <URPotentialCard {...rest} /> : <ListViewUniversalCard {...rest} />;
      break;
    case SearchViewMode.Grid:
      card = <SquareViewCard {...rest} />;
      break;
  }

  return (
    <ListingCardWrapper isActive={rest.isActive}>
      {card}
    </ListingCardWrapper>
  );
};

UniversalCard.defaultProps = {
  view: SearchViewMode.Grid,
};

export default UniversalCard;
